import { ReactNode, useState } from "react";
import { Layout } from "./Layout";
import { Home, Calendar, Settings } from "lucide-react";
import { useLocation } from "wouter";
import { Sidebar } from "@/components/layout/Sidebar";

interface GuestLayoutProps {
  children: ReactNode;
}

export default function GuestLayout({ children }: GuestLayoutProps) {
  const [location] = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  const navItems = [
    {
      label: "Dashboard",
      href: "/dashboard",
      icon: <Home className="w-5 h-5 mr-2" />,
      active: location === "/dashboard",
    },
    {
      label: "Bookings",
      href: "/bookings",
      icon: <Calendar className="w-5 h-5 mr-2" />,
      active: location === "/bookings" || location.startsWith("/bookings/"),
    },
    {
      label: "Settings",
      href: "/settings",
      icon: <Settings className="w-5 h-5 mr-2" />,
      active: location === "/settings",
    },
  ];

  return (
    <div className="flex min-h-screen">
      <Sidebar navItems={navItems} collapsed={collapsed} setCollapsed={setCollapsed} />
      <div className="flex flex-col flex-1 min-h-screen md:ml-64">
        <Layout>{children}</Layout>
      </div>
    </div>
  );
} 